import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormField from '../../../shared/form/_Field';
import Button from '../../../shared/form/_Button';
import Immutable from 'immutable';
import connect from 'react-redux/es/connect/connect';
import { getFormSyncErrors, getFormValues, reduxForm, touch } from 'redux-form/immutable';
import { validate } from '../../../../lib/validate';
import StateSelect from '../../../shared/form/_StateSelect';
import { updatePaymentDetails } from '../../../../actions/PaymentDetailsActions';
import { normalizeZipCode } from '../../../../lib/fieldsNormalization';

const FORM_NAME = 'paymentDetails';

class EditPaymentDetails extends Component {
    _handleSubmit = (e) => {
      e.preventDefault();
      const { formValues, valid, anyTouched, formTouch, paymentDetailsUpdate, cardId } = this.props;

      if (!anyTouched) {
        formTouch();
      }

      if (!valid) {
        return;
      }
      const parameters = {
        id: cardId,
        name: formValues.get('name'),
        address_city: formValues.get('city'),
        address_line1: formValues.get('address'),
        address_state: formValues.get('state'),
        address_zip: formValues.get('zipCode')
      };

      paymentDetailsUpdate(parameters);
    };

    _renderStateSelect = ({ input, meta, ...rest }) => {
      const value = input.value && input.value.length > 0 ? input.value : 'placeholder';

      return <StateSelect { ...input } { ...rest } value={ value } />;
    };
    render() {
      const { formValues, formSyncErrors, anyTouched, loading } = this.props;
      const errors = anyTouched ? formSyncErrors : Immutable.Map();

      return (
        <form className={ 'edit-payment-details__form' } onSubmit={ this._handleSubmit }>
          <FormField errors={ errors.get('name') } label={ 'Name' } name={ 'name' } value={ formValues.get('name') } />
          <FormField errors={ errors.get('address') } label={ 'Address' } name={ 'address' } value={ formValues.get('address') } />
          <FormField errors={ errors.get('city') } label={ 'City' } name={ 'city' } value={ formValues.get('city') } />
          <FormField errors={ errors.get('zipCode') } label={ 'Zip code' } name={ 'zipCode' } normalize={ normalizeZipCode } value={ formValues.get('zipCode') } />
          <FormField component={ this._renderStateSelect }
            errors={ errors.get('state') }
            inputClassName={ 'form__select' } label={ 'State' }
            name={ 'state' }
            value={ formValues.get('state') } />
          <div className='form__submit'>
            <Button className='form__button--green' loading={ loading }>update payment details</Button>
          </div>
        </form>
      );
    }
}

EditPaymentDetails.propTypes = {
  anyTouched: PropTypes.bool.isRequired,
  cardId: PropTypes.string.isRequired,
  formSyncErrors: PropTypes.instanceOf(Immutable.Map).isRequired,
  formTouch: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool.isRequired,
  paymentDetailsUpdate: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
  return {
    formValues:  getFormValues(FORM_NAME)(state) || Immutable.Map(),
    formSyncErrors:  Immutable.Map(getFormSyncErrors(FORM_NAME)(state)) || Immutable.Map(),
    cardId: state.getIn(['paymentDetails', 'data', 'id']),
    loading: state.getIn(['paymentDetails', 'loading']),
    initialValues: {
      name: state.getIn(['paymentDetails', 'data', 'billingDetails', 'name']),
      address: state.getIn(['paymentDetails', 'data', 'billingDetails', 'address']),
      city: state.getIn(['paymentDetails', 'data', 'billingDetails', 'city']),
      zipCode: state.getIn(['paymentDetails', 'data', 'billingDetails', 'zipCode']),
      state: state.getIn(['paymentDetails', 'data', 'billingDetails', 'state'])
    }
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formTouch: () => dispatch(touch(FORM_NAME)),
    paymentDetailsUpdate: (params) => dispatch(updatePaymentDetails(params))
  };
};

export default (connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    { form: FORM_NAME, touchOnBlur: false, validate }
  )(EditPaymentDetails)
));



// WEBPACK FOOTER //
// ./app/components/reps/settings/paymentMethods/_EditPaymentDetails.jsx